export const CORE_GET_ALL_USER_GROUP_REQUEST = "CORE_GET_ALL_USER_GROUP_REQUEST"
export const CORE_GET_ALL_USER_GROUP_SUCCESS = "CORE_GET_ALL_USER_GROUP_SUCCESS"
export const CORE_GET_ALL_USER_GROUP_FAILURE = "CORE_GET_ALL_USER_GROUP_FAILURE"

export const CORE_GET_USER_GROUP_BY_ID_REQUEST = "CORE_GET_USER_GROUP_BY_ID_REQUEST"
export const CORE_GET_USER_GROUP_BY_ID_SUCCESS = "CORE_GET_USER_GROUP_BY_ID_SUCCESS"
export const CORE_GET_USER_GROUP_BY_ID_FAILURE = "CORE_GET_USER_GROUP_BY_ID_FAILURE"

export const CORE_CREATE_USER_GROUP_REQUEST = "CORE_CREATE_USER_GROUP_REQUEST"
export const CORE_CREATE_USER_GROUP_SUCCESS = "CORE_CREATE_USER_GROUP_SUCCESS"
export const CORE_CREATE_USER_GROUP_FAILURE = "CORE_CREATE_USER_GROUP_FAILURE"

export const CORE_UPDATE_USER_GROUP_REQUEST = "CORE_UPDATE_USER_GROUP_REQUEST"
export const CORE_UPDATE_USER_GROUP_SUCCESS = "CORE_UPDATE_USER_GROUP_SUCCESS"
export const CORE_UPDATE_USER_GROUP_FAILURE = "CORE_UPDATE_USER_GROUP_FAILURE"


export const CORE_GET_ALL_FLOW_REQUEST = "CORE_GET_ALL_FLOW_REQUEST"
export const CORE_GET_ALL_FLOW_SUCCESS = "CORE_GET_ALL_FLOW_SUCCESS"
export const CORE_GET_ALL_FLOW_FAILURE = "CORE_GET_ALL_FLOW_FAILURE"

export const CORE_GET_FLOW_BY_ID_REQUEST = "CORE_GET_FLOW_BY_ID_REQUEST"
export const CORE_GET_FLOW_BY_ID_SUCCESS = "CORE_GET_FLOW_BY_ID_SUCCESS"
export const CORE_GET_FLOW_BY_ID_FAILURE = "CORE_GET_FLOW_BY_ID_FAILURE"

export const CORE_CREATE_FLOW_REQUEST = "CORE_CREATE_FLOW_REQUEST"
export const CORE_CREATE_FLOW_SUCCESS = "CORE_CREATE_FLOW_SUCCESS"
export const CORE_CREATE_FLOW_FAILURE = "CORE_CREATE_FLOW_FAILURE"

export const CORE_UPDATE_FLOW_REQUEST = "CORE_UPDATE_FLOW_REQUEST"
export const CORE_UPDATE_FLOW_SUCCESS = "CORE_UPDATE_FLOW_SUCCESS"
export const CORE_UPDATE_FLOW_FAILURE = "CORE_UPDATE_FLOW_FAILURE"

export const CORE_GET_ALL_COURSE_TYPE_REQUEST = "CORE_GET_ALL_COURSE_TYPE_REQUEST"
export const CORE_GET_ALL_COURSE_TYPE_SUCCESS = "CORE_GET_ALL_COURSE_TYPE_SUCCESS"
export const CORE_GET_ALL_COURSE_TYPE_FAILURE = "CORE_GET_ALL_COURSE_TYPE_FAILURE"

export const CORE_GET_COURSE_TYPE_BY_ID_REQUEST = "CORE_GET_COURSE_TYPE_BY_ID_REQUEST"
export const CORE_GET_COURSE_TYPE_BY_ID_SUCCESS = "CORE_GET_COURSE_TYPE_BY_ID_SUCCESS"
export const CORE_GET_COURSE_TYPE_BY_ID_FAILURE = "CORE_GET_COURSE_TYPE_BY_ID_FAILURE"

export const CORE_CREATE_COURSE_TYPE_REQUEST = "CORE_CREATE_COURSE_TYPE_REQUEST"
export const CORE_CREATE_COURSE_TYPE_SUCCESS = "CORE_CREATE_COURSE_TYPE_SUCCESS"
export const CORE_CREATE_COURSE_TYPE_FAILURE = "CORE_CREATE_COURSE_TYPE_FAILURE"

export const CORE_UPDATE_COURSE_TYPE_REQUEST = "CORE_UPDATE_COURSE_TYPE_REQUEST"
export const CORE_UPDATE_COURSE_TYPE_SUCCESS = "CORE_UPDATE_COURSE_TYPE_SUCCESS"
export const CORE_UPDATE_COURSE_TYPE_FAILURE = "CORE_UPDATE_COURSE_TYPE_FAILURE"


export const CORE_GET_ALL_COURSE_REQUEST = "CORE_GET_ALL_COURSE_REQUEST"
export const CORE_GET_ALL_COURSE_SUCCESS = "CORE_GET_ALL_COURSE_SUCCESS"
export const CORE_GET_ALL_COURSE_FAILURE = "CORE_GET_ALL_COURSE_FAILURE"

export const CORE_GET_COURSE_BY_ID_REQUEST = "CORE_GET_COURSE_BY_ID_REQUEST"
export const CORE_GET_COURSE_BY_ID_SUCCESS = "CORE_GET_COURSE_BY_ID_SUCCESS"
export const CORE_GET_COURSE_BY_ID_FAILURE = "CORE_GET_COURSE_BY_ID_FAILURE"

export const CORE_CREATE_COURSE_REQUEST = "CORE_CREATE_COURSE_REQUEST"
export const CORE_CREATE_COURSE_SUCCESS = "CORE_CREATE_COURSE_SUCCESS"
export const CORE_CREATE_COURSE_FAILURE = "CORE_CREATE_COURSE_FAILURE"

export const CORE_UPDATE_COURSE_REQUEST = "CORE_UPDATE_COURSE_REQUEST"
export const CORE_UPDATE_COURSE_SUCCESS = "CORE_UPDATE_COURSE_SUCCESS"
export const CORE_UPDATE_COURSE_FAILURE = "CORE_UPDATE_COURSE_FAILURE"

export const CORE_GET_COURSE_IMAGE_REQUEST = "CORE_GET_COURSE_IMAGE_REQUEST"
export const CORE_GET_COURSE_IMAGE_SUCCESS = "CORE_GET_COURSE_IMAGE_SUCCESS"
export const CORE_GET_COURSE_IMAGE_FAILURE = "CORE_GET_COURSE_IMAGE_FAILURE"

export const CORE_GET_ALL_COURSE_WAITING_APPROVE_REQUEST = "CORE_GET_ALL_COURSE_WAITING_APPROVE_REQUEST"
export const CORE_GET_ALL_COURSE_WAITING_APPROVE_SUCCESS = "CORE_GET_ALL_COURSE_WAITING_APPROVE_SUCCESS"
export const CORE_GET_ALL_COURSE_WAITING_APPROVE_FAILURE = "CORE_GET_ALL_COURSE_WAITING_APPROVE_FAILURE"

export const CORE_APPROVE_COURSE_REQUEST = "CORE_APPROVE_COURSE_REQUEST"
export const CORE_APPROVE_COURSE_SUCCESS = "CORE_APPROVE_COURSE_SUCCESS"
export const CORE_APPROVE_COURSE_FAILURE = "CORE_APPROVE_COURSE_FAILURE"

export const CORE_GET_ALL_COURSE_INCOMING_REQUEST = "CORE_GET_ALL_COURSE_INCOMING_REQUEST"
export const CORE_GET_ALL_COURSE_INCOMING_SUCCESS = "CORE_GET_ALL_COURSE_INCOMING_SUCCESS"
export const CORE_GET_ALL_COURSE_INCOMING_FAILURE = "CORE_GET_ALL_COURSE_INCOMING_FAILURE"

export const CORE_GET_COURSE_INCOMING_BY_ID_REQUEST = "CORE_GET_COURSE_INCOMING_BY_ID_REQUEST"
export const CORE_GET_COURSE_INCOMING_BY_ID_SUCCESS = "CORE_GET_COURSE_INCOMING_BY_ID_SUCCESS"
export const CORE_GET_COURSE_INCOMING_BY_ID_FAILURE = "CORE_GET_COURSE_INCOMING_BY_ID_FAILURE"

export const CORE_GET_COURSE_REQUEST_TO_JOIN_REQUEST = "CORE_GET_COURSE_REQUEST_TO_JOIN_REQUEST"
export const CORE_GET_COURSE_REQUEST_TO_JOIN_SUCCESS = "CORE_GET_COURSE_REQUEST_TO_JOIN_SUCCESS"
export const CORE_GET_COURSE_REQUEST_TO_JOIN_FAILURE = "CORE_GET_COURSE_REQUEST_TO_JOIN_FAILURE"

export const CORE_GET_COURSE_REQUEST_TO_JOIN_BY_ID_REQUEST = "CORE_GET_COURSE_REQUEST_TO_JOIN_BY_ID_REQUEST"
export const CORE_GET_COURSE_REQUEST_TO_JOIN_BY_ID_SUCCESS = "CORE_GET_COURSE_REQUEST_TO_JOIN_BY_ID_SUCCESS"
export const CORE_GET_COURSE_REQUEST_TO_JOIN_BY_ID_FAILURE = "CORE_GET_COURSE_REQUEST_TO_JOIN_BY_ID_FAILURE"

export const CORE_ADD_POINT_BY_USER_REQUEST = "CORE_ADD_POINT_BY_USER_REQUEST"
export const CORE_ADD_POINT_BY_USER_SUCCESS = "CORE_ADD_POINT_BY_USER_SUCCESS"
export const CORE_ADD_POINT_BY_USER_FAILURE = "CORE_ADD_POINT_BY_USER_FAILURE"

export const CORE_ADD_CERT_BY_USER_REQUEST = "CORE_ADD_CERT_BY_USER_REQUEST"
export const CORE_ADD_CERT_BY_USER_SUCCESS = "CORE_ADD_CERT_BY_USER_SUCCESS"
export const CORE_ADD_CERT_BY_USER_FAILURE = "CORE_ADD_CERT_BY_USER_FAILURE"

export const CORE_ADD_ATTACH_FILE_REQUEST = "CORE_ADD_ATTACH_FILE_REQUEST"
export const CORE_ADD_ATTACH_FILE_SUCCESS = "CORE_ADD_ATTACH_FILE_SUCCESS"
export const CORE_ADD_ATTACH_FILE_FAILURE = "CORE_ADD_ATTACH_FILE_FAILURE"


export const CORE_DOWNLOAD_ONEDIRVE_FILE_REQUEST = "CORE_DOWNLOAD_ONEDIRVE_FILE_REQUEST"
export const CORE_DOWNLOAD_ONEDIRVE_FILE_SUCCESS = "CORE_DOWNLOAD_ONEDIRVE_FILE_SUCCESS"
export const CORE_DOWNLOAD_ONEDIRVE_FILE_FAILURE = "CORE_DOWNLOAD_ONEDIRVE_FILE_FAILURE"


export const CORE_CANCEL_COURSE_REQUEST = "CORE_CANCEL_COURSE_REQUEST"
export const CORE_CANCEL_COURSE_SUCCESS = "CORE_CANCEL_COURSE_SUCCESS"
export const CORE_CANCEL_COURSE_FAILURE = "CORE_CANCEL_COURSE_FAILURE"


// WEBPACK FOOTER //
// ./src/app/redux/settingsType.js